import { render, staticRenderFns } from "./TabTabelaPreco.vue?vue&type=template&id=2ece477a&scoped=true&"
import script from "./TabTabelaPreco.vue?vue&type=script&lang=js&"
export * from "./TabTabelaPreco.vue?vue&type=script&lang=js&"
import style0 from "./TabTabelaPreco.vue?vue&type=style&index=0&id=2ece477a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece477a",
  null
  
)

export default component.exports